import { ResolveFn } from '@angular/router';
import { CurrentUserInfo } from '../services/user/user-information.model';
import { UserInformationService } from '../services/user/user-information.service';
import { inject } from '@angular/core';
import { filter, map, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';

export const userResolver: ResolveFn<CurrentUserInfo | null> = () => {
  const userInformationService: UserInformationService = inject(
    UserInformationService,
  );
  const authService = inject(AuthService);

  return userInformationService.getCurrentUser().pipe(
    filter((user: CurrentUserInfo | null | undefined) => !!user),
    map((user: CurrentUserInfo | null) => {
      if (!user) {
        void authService.logout();
        return null;
      }

      return user;
    }),
    catchError(() => {
      void authService.logout();
      return of(null);
    }),
  );
};
